export default __webpack_public_path__ + "static/media/bg_campaign.d97adb69.svg";